@if (page$ | async; as page) {
<portal-page (PortalActionEvent)="actionEvent($event)" (PortalUpdateEvent)="updateEvent($event)" (PortalErrorEvent)="errorEvent($event)" [element]="page"></portal-page>
}
